import { jsxs as n, jsx as e } from "react/jsx-runtime";
import { Popover as m, PopoverTrigger as a, PopoverContent as c, PopoverBody as g, Stack as p, Flex as h, Box as s } from "@chakra-ui/react";
import { Button as d } from "../../../forms/Button/Button.mjs";
import "../../../forms/Button/IconButton.mjs";
import "../../../forms/Button/ButtonGroup.mjs";
import { Switch as u } from "../../../forms/Switch/Switch.mjs";
import { ChevronDownIcon as f } from "../../../icons/componentIcons.mjs";
import { Typography as b } from "../../Typography/Typography.mjs";
const B = ({
  allColumns: t,
  id: i
}) => /* @__PURE__ */ n(m, { children: [
  /* @__PURE__ */ e(a, { children: /* @__PURE__ */ e(
    d,
    {
      variant: "tertiary",
      size: "sm",
      rightIcon: /* @__PURE__ */ e(f, { size: "sm", variant: "light" }),
      children: "Columns"
    }
  ) }),
  /* @__PURE__ */ e(c, { children: /* @__PURE__ */ e(g, { children: /* @__PURE__ */ e(p, { children: t.filter((r) => {
    var o;
    return ((o = r.columnDef.meta) == null ? void 0 : o.isToggleable) ?? !0;
  }).map((r, o) => {
    var l;
    return /* @__PURE__ */ n(h, { gap: 2, children: [
      /* @__PURE__ */ e(s, { children: /* @__PURE__ */ e(
        u,
        {
          size: "sm",
          isChecked: r.getIsVisible(),
          onChange: r.getToggleVisibilityHandler(),
          name: `${i}--column-toggle-${o}`,
          "aria-labelledby": `${i}--column-label-${o}`
        }
      ) }),
      /* @__PURE__ */ e(b, { variant: "bodySmall", id: `${i}--column-label-${o}`, children: ((l = r.columnDef.meta) == null ? void 0 : l.columnName) ?? r.id })
    ] }, r.id);
  }) }) }) })
] });
export {
  B as ColumnToggle
};
